<template>
    <v-dialog width="700px" v-model="dialog" >

        <template v-slot:activator="{ on }">
            <v-btn
                    small
                    class="float-right primary"
                    depressed
                    v-on="on"
            ><!--<v-icon left x-small>mdi-pencil</v-icon>-->View
            </v-btn>
        </template>

        <v-card>
            <v-card-title>
                <span class="headline">Edit Driver</span>
                <div class="dialog-closeBtn" @click="dialog = false"><v-icon left>mdi-close</v-icon></div>
            </v-card-title>
            <v-card-text>
                <v-container>
                    <v-form ref="form"

                    >
                        <v-row>
                            <v-col cols="12" sm="6" md="6">
                                <v-text-field
                                        clear-icon="mdi-close"
                                        clearable
                                        outlined
                                        label="First Name*"
                                        hint="enter first name"
                                        required
                                        v-model="firstName"
                                        :disabled="true"
                                        :error-messages="firstNameErrors"
                                        @input="$v.firstName.$touch()"
                                        @blur="$v.firstName.$touch()"
                                ></v-text-field>
                            </v-col>

                            <v-col cols="12" sm="6" md="6">
                                <v-text-field
                                        clear-icon="mdi-close"
                                        clearable
                                        outlined
                                        label="Last Name*"
                                        hint="enter a last name"
                                        v-model="lastName"
                                        :disabled="true"
                                        :error-messages="lastNameErrors"
                                        required
                                        @input="$v.lastName.$touch()"
                                        @blur="$v.lastName.$touch()"
                                ></v-text-field>
                            </v-col>

                            <v-col cols="12" sm="12">
                                <v-text-field
                                        clear-icon="mdi-close"
                                        clearable
                                        outlined
                                        label="Driver Email*"
                                        required
                                        v-model="email"
                                        :disabled="true"
                                        :error-messages="emailErrors"
                                        @input="$v.email.$touch()"
                                        @blur="$v.email.$touch()"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                                <v-text-field
                                        clear-icon="mdi-close"
                                        clearable
                                        outlined
                                        label="Address_1"
                                        v-model="address_1"
                                        :disabled="true"
                                        persistent-hint
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                                <v-text-field
                                        clear-icon="mdi-close"
                                        clearable
                                        outlined
                                        label="Address_2"
                                        v-model="address_2"
                                        :disabled="true"
                                        persistent-hint
                                ></v-text-field>
                            </v-col>

                            <v-col cols="12" sm="6" md="6">
                                <v-text-field
                                        clear-icon="mdi-close"
                                        clearable
                                        outlined
                                        label="City"
                                        hint="Enter city"
                                        v-model="city"
                                        :disabled="true"
                                ></v-text-field>
                            </v-col>

                            <v-col cols="12" sm="6" md="6">
                                <v-text-field
                                        clear-icon="mdi-close"
                                        clearable
                                        outlined
                                        label="Postcode"
                                        hint="Enter postcode"
                                        v-model="postcode"
                                        :disabled="true"
                                ></v-text-field>
                            </v-col>


                            <v-col cols="6" sm="6">
                                <v-text-field
                                        clear-icon="mdi-close"
                                        clearable
                                        outlined
                                        label="Telephone Number"
                                        type="Telephone"
                                        v-model="telephone"
                                        :disabled="true"
                                ></v-text-field>
                            </v-col>

                            <v-col cols="12" sm="6" md="6">
                                <v-text-field
                                        clear-icon="mdi-close"
                                        clearable
                                        outlined
                                        label="Emergency contact name"
                                        v-model="emergency_contact_name"
                                        :disabled="true"
                                        persistent-hint
                                ></v-text-field>
                            </v-col>

                            <v-col cols="12" sm="6" md="6">
                                <v-text-field
                                        clear-icon="mdi-close"
                                        clearable
                                        outlined
                                        label="Emergency contact phone"
                                        v-model="emergency_contact_phone"
                                        :disabled="true"
                                        persistent-hint
                                ></v-text-field>
                            </v-col>

                            <v-col cols="12" sm="6" md="6">
                                <v-text-field
                                        clear-icon="mdi-close"
                                        clearable
                                        outlined
                                        label="Bank sort code"
                                        v-model="bank_sort_code"
                                        :disabled="true"
                                        persistent-hint
                                ></v-text-field>
                            </v-col>

                            <v-col cols="12" sm="6" md="6">
                                <v-text-field
                                        clear-icon="mdi-close"
                                        clearable
                                        outlined
                                        label="Bank account number"
                                        v-model="bank_account_number"
                                        :disabled="true"
                                        persistent-hint
                                ></v-text-field>
                            </v-col>

                            <v-col cols="12" sm="12" class="area-select">
                                <v-select
                                        outlined
                                        label="Areas Assigned to*"
                                        multiple
                                        chips
                                        deletable-chips
                                        hint="leave blank not to assign driver to any areas"
                                        persistent-hint
                                        v-model="area_ids"
                                        :disabled="true"
                                        :items="areasList"
                                        item-text="name"
                                        item-value="id"
                                        :error-messages="selectAreaErrors"
                                        @change="onChangeArea"
                                        @blur="$v.area_ids.$touch()"
                                ></v-select>
                            </v-col>
                            <v-col cols="12" sm="12" class="drivers_resturants-select">
                                <v-select
                                        outlined
                                        label="Area's Restaurants Assigned to"
                                        multiple
                                        chips
                                        deletable-chips
                                        hint="if leave blank driver to be assigned to all Area's restaurants"
                                        persistent-hint
                                        v-model="restaurant_ids"
                                        :disabled="true"
                                        :items="restaurantsList"
                                        item-text="name"
                                        item-value="id"
                                        :error-messages="selectRestaurantErrors"
                                        @change="onChangeRestaurant"
                                        @blur="$v.restaurant_ids.$touch()"
                                ></v-select>
                            </v-col>

                        </v-row>
                    </v-form>
                </v-container>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
    import {validationMixin} from 'vuelidate'
    import {required, /* maxLength,*/ email, /*numeric*/} from 'vuelidate/lib/validators'
    import {mapGetters} from 'vuex'
    import * as _ from 'lodash'

    export default {
        mixins: [validationMixin],
        name: "NewLocationModal",
        props: ['thisDriverData', 'btnLabel'],
        validations: {
            firstName: {required, /* maxLength: maxLength(10)*/},
            email: {required, email},
            // telephone: {required, /*numeric*/},
            lastName: {required},
            // area: {required},
            // address_1: { required },
            // address_2: { required }
            // emergency_contact_name: { },
            // emergency_contact_phone: { },
            // bank_sort_code: { },
            // bank_account_number: { },
            area_ids: {},
            restaurant_ids: {}
        },
        data: () => ({
            switch_change_password: false,
            showPassword: false,
            passwordRules: [
                v => !!v || 'Please enter your password',
                v => (v && v.length >= 6) || 'Password should be at least six symbols long'
            ],
            /*valid: false,*/
            driverData: null,
            readOnly: false,
            localLoading: false,
            dialog: false,
            firstName: '',
            email: '',
            address_1: '',
            address_2: '',
            emergency_contact_name: '',
            emergency_contact_phone: '',
            bank_sort_code: '',
            bank_account_number: '',
            lastName: '',
            telephone: '',
            city: '',
            postcode: '',
            password: '',
            area_ids: [],
            restaurant_ids: [],
        }),
        computed: {
            ...mapGetters([
                'areas',
                'restaurants',
            ]),
            selectAreaErrors () {
                const errors = [];
                if (!this.$v.area_ids.$dirty) {
                    return errors;
                }
                // !this.$v.area_ids.required && errors.push('Area is required');
                return errors
            },
            selectRestaurantErrors () {
                const errors = [];
                if (!this.$v.restaurant_ids.$dirty) {
                    return errors;
                }
                // !this.$v.restaurant_ids.required && errors.push('Resturants is required');
                return errors
            },
            firstNameErrors () {
                const errors = []
                if (!this.$v.firstName.$dirty) return errors
                /*!this.$v.name.maxLength && errors.push('Name must be at most 10 characters long')*/
                !this.$v.firstName.required && errors.push('First name is required.')
                return errors
            },
            lastNameErrors () {
                const errors = []
                if (!this.$v.lastName.$dirty) return errors
                !this.$v.lastName.required && errors.push('Last Name is required.')
                return errors
            },
            emailErrors () {
                const errors = []
                if (!this.$v.email.$dirty) return errors
                !this.$v.email.email && errors.push('Must be valid e-mail')
                !this.$v.email.required && errors.push('E-mail is required')
                return errors
            },
            areasList() {
                return this.areas;
            },
            restaurantsList() {
                if (this.area_ids.length == 0) {
                    return [];
                }

                return _.filter(this.restaurants, p => this.area_ids.indexOf(+p.area_id) !== -1);
            },
        },
        created(){
            // --
        },
        mounted()
        {
            this.driverData = this.thisDriverData;
            this.id = this.thisDriverData.id;
            this.firstName = this.thisDriverData.first_name;
            this.lastName = this.thisDriverData.last_name;
            this.email = this.thisDriverData.email;
            this.address_1 = this.thisDriverData.address_1;
            this.address_2 = this.thisDriverData.address_2;
            this.emergency_contact_name = this.thisDriverData.emergency_contact_name;
            this.emergency_contact_phone = this.thisDriverData.emergency_contact_phone;
            this.bank_sort_code = this.thisDriverData.bank_sort_code;
            this.bank_account_number = this.thisDriverData.bank_account_number;
            this.telephone = this.thisDriverData.phone;
            this.city = this.thisDriverData.city;
            this.postcode = this.thisDriverData.postcode;
            this.status = this.thisDriverData.status;
            this.area_ids = _.map(this.thisDriverData.area_ids, p => +p.area_id);
            this.restaurant_ids = _.map(this.thisDriverData.restaurant_ids, p => +p.restaurant_id);
        },


        methods: {
            onChangeArea (/*values*/) {
                let areas_restaurants = _.map(this.restaurantsList, p => p.id);

                // clear selected restaurants on change area
                this.restaurant_ids = _.intersection(areas_restaurants, this.restaurant_ids);
            },
            onChangeRestaurant(/*values*/) {
                // debugger;
            },
            cancel(){
                this.id = this.thisDriverData.id;
                this.firstName = this.thisDriverData.first_name;
                this.lastName = this.thisDriverData.last_name;
                this.email = this.thisDriverData.email;
                this.address_1 = this.thisDriverData.address_1;
                this.address_2 = this.thisDriverData.address_2;
                this.emergency_contact_name = this.thisDriverData.emergency_contact_name;
                this.emergency_contact_phone = this.thisDriverData.emergency_contact_phone;
                this.bank_sort_code = this.thisDriverData.bank_sort_code;
                this.bank_account_number = this.thisDriverData.bank_account_number;
                this.telephone = this.thisDriverData.phone;
                this.city = this.thisDriverData.city;
                this.postcode = this.thisDriverData.postcode;
                this.status = this.thisDriverData.status;
                this.area_ids = _.map(this.thisDriverData.area_ids, p => +p.area_id);
                this.restaurant_ids = _.map(this.thisDriverData.restaurant_ids, p => +p.restaurant_id);

                this.dialog = false;
            },
            submit () {
                this.localLoading = true;
                this.dialog = true;
                this.$v.$touch();

                if (!this.$v.$invalid) {
                    const driver_data = {
                        id: this.id,
                        first_name: this.firstName,
                        last_name: this.lastName,
                        email: this.email,
                        address_1: this.address_1,
                        address_2: this.address_2,
                        emergency_contact_name: this.emergency_contact_name,
                        emergency_contact_phone: this.emergency_contact_phone,
                        bank_sort_code: this.bank_sort_code,
                        bank_account_number: this.bank_account_number,
                        phone: this.telephone,
                        city: this.city,
                        postcode: this.postcode,
                        area_ids: this.area_ids,
                        restaurant_ids: this.restaurant_ids,
                    };

                    if (this.switch_change_password) {
                        driver_data.password = this.password;
                    }

                    this.$store.dispatch('editDriver', driver_data).then(() => {
                        this.dialog = false;
                        this.password = '';
                        this.switch_change_password = false;
                        this.$emit('driverUpdated', '');
                    })
                        .catch(error => {
                            this.email = '';
                            let errors = error.response;
                            this.$store.dispatch('setError', errors[Object.keys(errors)[0]][0]);
                        })
                        .finally(() => {
                            this.localLoading = false;
                        });
                }
            },
        },
    }
</script>

<style scoped>

</style>
